import React from 'react';
import { PhoneIcon, HomeIcon, ClockIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  const services = t('footer.serviceList');
  return <footer className="bg-black pt-20 pb-10 border-t-4 border-brand-gold" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-112">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/r65Do7snHotGvJ9xDGDVi3/heylloyd-image-1774744993354.png" alt="Benitez Handyman Construction Logo" className="h-32 w-auto object-contain rounded mb-6" data-id="element-114" />
            <p className="text-xl text-gray-400 font-medium max-w-md" data-id="element-115">
              {t('footer.description')}
            </p>
          </div>

          {/* Contact Column */}
          <div data-id="element-116">
            <h4 className="text-2xl font-heading font-bold text-white mb-6 uppercase tracking-wider" data-id="element-117">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-4" data-id="element-118">
              <li data-id="element-119">
                <a href="tel:2029132653" className="flex items-center gap-3 text-lg text-brand-gold hover:text-brand-gold-light transition-colors group" data-id="element-120">
                  <div className="bg-brand-gold/10 p-2 rounded-full group-hover:bg-brand-gold/20 transition-colors" data-id="element-121">
                    <PhoneIcon className="w-5 h-5" data-id="element-122" />
                  </div>
                  <span className="font-bold tracking-wide" data-id="element-123">
                    (202) 913-2653
                  </span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400" data-id="element-124">
                <div className="bg-gray-800 p-2 rounded-full mt-1" data-id="element-125">
                  <HomeIcon className="w-5 h-5 text-gray-300" data-id="element-126" />
                </div>
                <div data-id="element-127">
                  <p className="font-medium text-white mb-1" data-id="element-128">
                    {t('footer.serviceArea')}
                  </p>
                  <p data-id="element-129">MD | DC | VA</p>
                  <p className="text-sm mt-1" data-id="element-130">{t('footer.base')}</p>
                </div>
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-131">
                <div className="bg-gray-800 p-2 rounded-full" data-id="element-132">
                  <ClockIcon className="w-5 h-5 text-gray-300" data-id="element-133" />
                </div>
                <span className="font-medium text-white" data-id="element-134">
                  {t('footer.availability')}
                  <span className="text-brand-gold" data-id="element-135">24/7</span>
                </span>
              </li>
            </ul>
          </div>

          {/* Quick Links / Info */}
          <div data-id="element-136">
            <h4 className="text-2xl font-heading font-bold text-white mb-6 uppercase tracking-wider" data-id="element-137">
              {t('footer.services')}
            </h4>
            <ul className="space-y-2 text-gray-400" data-id="element-138">
              {Array.isArray(services) && services.map((service: string, index: number) => <li key={index} data-id="element-139">{service}</li>)}
            </ul>
          </div>
        </div>

        <div className="flex justify-center mb-8" data-id="element-140">
          <a href="#inicio" className="flex flex-col items-center gap-2 text-gray-400 hover:text-brand-gold transition-colors group" data-id="element-141">
            <div className="bg-brand-gold/10 group-hover:bg-brand-gold/20 p-3 rounded-full transition-colors" data-id="element-142">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-143">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" data-id="element-144" />
              </svg>
            </div>
            <span className="text-sm font-heading uppercase tracking-widest" data-id="element-145">
              {t('footer.backToTop')}
            </span>
          </a>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-146">
          <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-147">
            &copy; {new Date().getFullYear()} BENITEZ HANDYMAN CONSTRUCTION.
            {t('footer.rights')}
          </p>
          <div className="flex gap-4" data-id="element-148">
            <span className="text-brand-gold text-sm font-heading tracking-widest uppercase" data-id="element-149">
              MD • DC • VA
            </span>
          </div>
        </div>
      </div>
    </footer>;
}